import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#F5F5F5'


const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: '#F5F5F5',
    borderBottomColor: borderColor,
    // borderBottomWidth: 1,
    alignItems: 'center',
    height: 24,
    textAlign: 'left',
    fontWeight: 'bold',
    flexGrow: 1,
    paddingLeft: 8,
  },
  refrence: {
    width: '25%',
    borderRightColor: 'black',
    // borderRightWidth: 1,
    fontSize: 9,
  },
  description: {
    width: '25%',
    borderRightColor: 'black',
    // borderRightWidth: 1,
    fontSize: 9,
  },
  details: {
    width: '30%',
    borderRightColor: 'black',
    // borderRightWidth: 1,
    fontSize: 9,
  },
  service_date: {
    width: '20%',
    fontSize: 9,
  },
});

const InvoiceTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.refrence}>Booking ID</Text>
    <Text style={styles.description}>Booking Item</Text>
    <Text style={styles.details}>Details</Text>
    <Text style={styles.service_date}>Service Date</Text>
  </View>
);

export default InvoiceTableHeader;
